import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const lookAndFeelRoute: InvariantJiraRoute = {
	name: 'look-and-feel',
	path: '/jira/settings/system/ui/look-and-feel',
};
